import React from "react";
import PDF from "../../../../assets/svg/btn_icons/print-pdf.svg";

function PDFExport({ handlePDFExport, title = "Export to Pdf" }) {
  return (
    <button
      type="button"
      className={`btn btn-soft-gray button-btn-label button-lg`}
      onClick={handlePDFExport}
    >
      <img src={PDF} alt="" className="export-btn-img" />
      <span className="font-size-14">{title?.toUpperCase()} </span>
    </button>
  );
}

export default PDFExport;
